import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { HEADER, APPOINTMENTS, REFERRAL } from '_constants';
import { headerActions, appointmentActions } from 'actions';
import { APPOINTMENT_STATUS } from '../../../constants/appointments.constants';
import StepInstruction from '../../common/StepInstruction';
import _ from 'lodash';

class CancelAppointment extends React.Component {
    static propTypes = {
      appointments: PropTypes.object.isRequired,
      appointment: PropTypes.object.isRequired,
      fetchDispositions: PropTypes.func.isRequired,
      getSelectDisposition: PropTypes.func.isRequired,
      setHeader: PropTypes.func.isRequired,
      cancelAppointment: PropTypes.func.isRequired,
      history: PropTypes.object.isRequired,
      displayDispositionInfo: PropTypes.func.isRequired,
      referral: PropTypes.object.isRequired
    }

    state = {
      selectedReason: APPOINTMENTS.SELECT_REASON,
      countMet: false,
      cancelNotes: '',
      triedToSubmit: false,
      step1: { num: 1, bgColor: 'bg-blue-shade', showCheckMark: false },
      step2: { num: 2, bgColor: 'bg-silver', showCheckMark: false },
      selectItems: [],
      updatedDispositions: []
    }

    onChangeAction = (event) => {
      const reason = event.target.value;
      this.setState((state) => ({
        selectedReason: reason,
        step1: { ...state.step1, showCheckMark: true },
        step2: { ...state.step2, bgColor: 'bg-blue-shade' }
      }));
    }

    confirmCount = () => {
      if (this.state.cancelNotes.length >= 20) {
        this.setState((state) => ({
          countMet: true,
          step2: { ...state.step2, showCheckMark: true }
        }));
      } else {
        this.setState((state) => ({
          countMet: false,
          step2: { ...state.step2, showCheckMark: false }
        }));
      }
    }

    cancelAppointment = (history) => {
      const isFromAppointmentDetails = _.get(this.props, 'location.state.from', null);
      this.setState({ triedToSubmit: true });
      if (this.state.countMet && this.state.selectedReason !== APPOINTMENTS.SELECT_REASON) {
        this.props.appointment.notes = this.state.cancelNotes;
        if (_.isEqual(isFromAppointmentDetails, 'appointmentDetails')) {
          this.props.cancelAppointment(this.props.appointment, this.state.selectedReason, history, true);
        } else {
          this.props.cancelAppointment(this.props.appointment, this.state.selectedReason, history);
        }
      }
    }

    handleChange = (event) => {
      this.setState({
        cancelNotes: event.target.value
      }, this.confirmCount);
    }

    handleClick = () => {
      this.setState((state) => ({
        step2: { ...state.step2, bgColor: 'bg-blue-shade' }
      }));
    }

    componentDidMount = async () => {
      this.props.setHeader({
        type: HEADER.UPDATE_HEADER,
        showHeader: true,
        headerTitle: 'Cancel Appointment',
        hasBackButton: true,
        backButtonIcon: 'back'
      });
      await this.props.fetchDispositions(APPOINTMENT_STATUS.CANCELLED.id);
      const { appointments, appointment, referral } = this.props;
      const dispositionList = appointments && appointments.dispositions && appointments.dispositions[APPOINTMENT_STATUS.CANCELLED.id];
      const { selectItems, updatedDispositions } = this.props.getSelectDisposition(dispositionList, appointment, referral);
      this.setState({
        selectItems,
        updatedDispositions,
        selectedReason: updatedDispositions.length === 1 ? updatedDispositions[0]?.disposition?.dispositionKey : APPOINTMENTS.SELECT_REASON
      });
    }

    render () {
      const { cancelNotes, selectedReason, countMet, triedToSubmit, step1, step2, selectItems, updatedDispositions } = this.state;
      const checkMark = <span>&#10003;</span>;

      return (
        <React.Fragment>
          <div className='cancel-appointment-label'>
            <StepInstruction badgeDisplay={step1.showCheckMark ? checkMark : step1.num} bgcolor={step1.bgColor} />
            <div className={'cancel-reason-info'}>
              <span className={'cancel-question'}>Why are you cancelling?</span>
              {!_.isEmpty(updatedDispositions) && <i className={'material-icons material-icons-info description-icon'} onClick={() => this.props.displayDispositionInfo(updatedDispositions, 'Cancelling Reasons')} />}
            </div>
            {
              triedToSubmit && selectedReason === APPOINTMENTS.SELECT_REASON &&
              <span className='sub-label-text'> *Please select the reason</span>
            }
          </div>
          <div className='margin-lr-10 select-status-custom'>
            <select className='reason form-control' value={selectedReason} onChange={this.onChangeAction}>
              {selectItems}
            </select>
          </div>

          <div className='cancel-appointment-note'>
            <StepInstruction badgeDisplay={step2.showCheckMark ? checkMark : step2.num} bgcolor={step2.bgColor} />
            <span>Notes</span>
            {
              triedToSubmit && !countMet
                ? <span className='sub-label-text'> *Please enter at least 20 characters</span>
                : <span className='appointment-small-text'> (20 characters min.)</span>
            }
          </div>

          <div className='margin-lr-10'>
            <textarea
              className='appointment-notes'
              placeholder=' How did the appointment go?'
              maxLength='160'
              rows='4'
              onChange={this.handleChange}
              onClick={this.handleClick}
            />
          </div>
          <div className='text-characters-count'>
            {`(${cancelNotes.length}/160)`}
          </div>
          <div className='appointment-disclaimer'>
            <div className='float-left alert-red-text'>*</div>
            <div>{REFERRAL.NOTE_DISCLAMIER}</div>
          </div>
          <div className='bottom-container'>
            <button
              className='appointment-primary-button'
              onClick={() => this.cancelAppointment(this.props.history)}>Cancel Appointment
            </button>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  cancelAppointment: bindActionCreators(appointmentActions.cancelAppointment, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CancelAppointment));
